<template>
    <div>
        <div
            class='w-100 p-2 text-center rounded-top'
            :style="$bgColor(color.primary)"
        >
            <h3
                class='card-title mt-2 mb-0'
                :style="{ color: color.secondary }"
            >
                {{ $t('gamification.gamification_my_points') }}
            </h3>
        </div>
        <card class='container rounded-bottom'>
            <div class='gamification-header'>
                <div class='gamification-points-header'>
                    <span
                        class='gamification-plan'
                        :style="{color: color.primary}"
                    >
                        {{ this.studentPlans.length > 0 ? this.studentPlans[this.currentStudentPlanGoal].name : $t('common.plan') }}
                    </span>
                    <gamification-box
                        :value="`${studentPlanGoals && studentPlanGoals.total_points !== null ? studentPlanGoals.total_points : 0} ${$t('gamification.gamification_points')}`"
                        :color="color"
                    />
                    <button
                        type="button"
                        class='nch-next-plan-button'
                        @click="getNextPlanPoints"
                    >
                        <i
                            class='mdi mdi-reply-all mdi-flip-h mdi-48px'
                            :style="{ color: color.primary }"
                        ></i>
                    </button>
                </div>
            </div>
            <div class='gamification-points-body'>
                <template
                    v-if="studentPlanGoals && studentPlanGoals.goals && studentPlanGoals.goals.length > 0"
                >
                    <i class='mdi mdi-xbox-controller'></i>

                    <i class='mdi mdi-rocket'></i>
                    <i class='mdi mdi-chart-line'></i>
                    <i class='mdi mdi-flag-checkered'></i>
                    <i class='mdi mdi-trophy'></i>
                    <div
                        v-for="(goals,i) in studentPlanGoals.goals.slice(0, 7)"
                        :key="i"
                    >
                        <gamification-content-points
                            :contentText="goals.name ? goals.name : $t(`gamification.${goals.goal_type}_title`)"
                            :pointsText="`${goals.points} ${$t('gamification.gamification_points')}`"
                            :color="color"
                        />
                    </div>
                    <i class='mdi mdi-map-marker-circle'></i>
                </template>
                <template
                    v-else
                >
                    {{ $t('gamification.gamification_content_without_progress') }}
                </template>
            </div>
            <div class='gamification-points-button'>
                <button
                    type="button"
                    class='nch-show-progress-button'
                    @click="getHoleProgress"
                >
                    {{ $t('gamification.gamification_show_hole_progress') }}
                </button>
            </div>
        </card>
    </div>
</template>
    
<script>
import Card from '../../argon/components/Cards/Card';
import GamificationBox from './GamificationBox';
import GamificationArrow from './GamificationArrow';
import GamificationContentPoints from './GamificationContentPoints';
    
export default {
    name: 'GamificationPoints',

    components: {
        Card,
        GamificationBox,
        GamificationArrow,
        GamificationContentPoints,
    },

    props: {
        gamificationRules: Object,
        color: {
            type: Object,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
        studentPlans: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            studentPlanGoals: null,
            currentStudentPlanGoal: 0,
        };
    },

    methods: {
        async getNextPlanPoints() {
            if (this.studentPlans.length > 0) {
                if (this.currentStudentPlanGoal + 1 < this.studentPlans.length) {
                    this.currentStudentPlanGoal++;
                } else {
                    this.currentStudentPlanGoal = 0;
                }
                await this.getStudentGoals(this.studentPlans[this.currentStudentPlanGoal].id);
            }
        },

        async getHoleProgress() {
            if (this.currentStudentPlanGoal !== -1 && this.studentPlans.length > 0) {
                const planId = this.studentPlans[this.currentStudentPlanGoal].id;
                window.location.href = `/app/gamification/plan/${planId}/progress`;
            }
        },

        async getStudentGoals(planId) {
            return window.axios
                .get(`/api/gamification/goals/student/${this.student.id}/plan/${planId}`)
                .then(response => {
                    this.studentPlanGoals = response.data.data;
                    const goals = response.data.data.goals[0];
                    var newGoals = goals.attendance
                        .filter(item => item.points > 0)
                        .concat(
                            goals.certificates.filter(item => item.points > 0),
                            goals.courses.filter(item => item.points > 0),
                            goals.exercises.filter(item => item.points > 0),
                            goals.lessons.filter(item => item.points > 0),
                            goals.modules.filter(item => item.points > 0),
                            goals.surveys.filter(item => item.points > 0)
                        );

                    // Ordena o array para que esteja em ordem decrescente, para que seja possível
                    // pegar as 7 últimas pontuações do aluno
                    newGoals.sort((a, b) => {
                        let dateA = new Date(a.updated_at).getTime();
                        let dateB = new Date(b.updated_at).getTime();
                        return dateB - dateA;
                    });
                    this.studentPlanGoals.goals = newGoals;
                })
                .catch(err => {
                    this.$notify({
                        type: 'danger',
                        message: err.response.data.error,
                    });
                    this.$emit('error', false)
                });
        },
    },

    async mounted() {
        // Verifica se o aluno e os planos estão definidos para então buscar as metas
        // do aluno
        if (this.student && this.studentPlans.length > 0) {
            await this.getStudentGoals(this.studentPlans[0].id);
        }
    }
};
</script>
    
<style scoped>
    .gamification-header {
        width: 100%;
        background-color: #EBEBEB;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-header {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-body {
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-points-button {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .gamification-plan {
        padding: 5px 25px 5px 25px;
        height: 40px;
        border: 3px solid #5E72E4;
        border-radius: 50px;
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        margin-right: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 550px;
    }

    .gamification-plan::after {
        content: '...';
    }

    .gamification-plan:not(:empty)::after {
        content: '';
    }

    .nch-show-progress-button {
        padding: 5px 25px 5px 25px;
        height: 40px;
        border: none;
        border-radius: 50px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
        background-color: #5E72E4;
        margin-top: 30px;
    }

    .nch-show-progress-button:focus {
        outline: none;
    }

    .card-title {
        font-size: 20px;
        font-weight: bold;
    }

    .rounded-top {
        border-top-left-radius: 25px !important;
        border-top-right-radius: 25px !important;
    }

    .rounded-bottom {
        border-bottom-left-radius: 25px !important;
        border-bottom-right-radius: 25px !important;
    }

    .nch-next-plan-button {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 10px;
    }

    .nch-next-plan-button:focus {
        outline: none;
    }

    .mdi-xbox-controller {
        color: #F39B1F;
        font-size: 80px;
        margin-top: -100px;
        margin-right: 30px;
    }

    .mdi-map-marker-circle {
        color: #FFE543;
        font-size: 80px;
        margin-top: -100px;
        z-index: 10;
    }

    .mdi-rocket {
        color: #0EB0BF;
        position: absolute;
        top: 100px;
        left: 10px;
        font-size: 80px;
        margin-top: -100px;
        z-index: 10;
    }

    .mdi-chart-line {
        color: #02ECC5;
        position: absolute;
        right: 10px;
        font-size: 80px;
        margin-top: -100px;
        z-index: 10;
    }

    .mdi-flag-checkered {
        color: #D65B70;
        position: absolute;
        bottom: 50px;
        right: 100px;
        font-size: 80px;
        z-index: 10;
    }

    .mdi-trophy {
        color: #44B788;
        position: absolute;
        left: 10px;
        font-size: 80px;
        z-index: 10;
    }

    @media (max-width: 435px) {
        .mdi-xbox-controller {
            margin-top: -30px;
            padding: 0 100px;
            margin-right: 0px;
        }
        .mdi-map-marker-circle {
            color: #FFE543;
            font-size: 80px;
            margin-top: -20px;
        }
        .gamification-header {
            height: 140px;
        }
        .gamification-plan {
            margin-right: 0px;
            margin-bottom: 10px;
            text-align: center;
	        width: 80vw;
        }
        .gamification-points-body {
            margin-top: 140px;
        }
        .nch-show-progress-button {
            height: 30px;
            font-size: 15px;
        }
        .row {
            margin-right: 0px;
            margin-left: 0px;
        }
    }

    @media (min-width: 436px) and (max-width: 575px) {
        .mdi-xbox-controller {
            margin-top: -30px;
            padding: 0 100px;
            margin-right: 0px;
        }
        .gamification-header {
            height: 140px;
        }
        .gamification-plan {
            margin-right: 0px;
            margin-bottom: 10px;
            text-align: center;
	        width: 80vw;
        }
        .gamification-points-body {
            margin-top: 140px;
        }
        .nch-show-progress-button {
            height: 30px;
            font-size: 15px;
        }
        .row {
            margin-right: 0px;
            margin-left: 0px;
        }
    }

    @media (min-width: 576px) and (max-width: 650px) {
        .mdi-xbox-controller {
            margin-top: -30px;
            padding: 0 100px;
            margin-right: 0px;
        }
        .gamification-header {
            height: 140px;
        }
        .gamification-plan {
            margin-right: 0px;
            margin-bottom: 10px;
            text-align: center;
	        width: 75vw;
        }
        .gamification-points-body {
            margin-top: 140px;
        }
        .nch-show-progress-button {
            height: 30px;
            font-size: 15px;
        }
        .row {
            margin-right: 0px;
            margin-left: 0px;
        }
    }

    @media (min-width: 651px) and (max-width: 767px) {
        .mdi-xbox-controller {
            margin-top: -30px;
            padding: 0 100px;
            margin-right: 0px;
        }
        .gamification-header {
            height: 140px;
        }
        .gamification-plan {
            margin-right: 0px;
            margin-bottom: 10px;
            text-align: center;
	        width: 65vw;
        }
        .gamification-points-body {
            margin-top: 140px;
        }
        .row {
            margin-right: 0px;
            margin-left: 0px;
        }
    }
</style>
    